document.addEventListener('DOMContentLoaded', function () {
  function lockBody() {
    document.body.classList.add('is-locked');
  }
  function unlockBody() {
    document.body.classList.remove('is-locked');
  }
  document.addEventListener('click', function (e) {

    const trigger = e.target.closest('.product-block--custom_policy');
    const item = trigger && trigger.closest('.item');

    if (item) {
      e.preventDefault();
      e.stopPropagation();

      document.querySelectorAll('.product-shop-ease-module .item.is-open')
        .forEach(el => {
          el.classList.remove('is-open');
          const pop = el.querySelector('.protection_item_pop');
          if (pop) pop.style.display = 'none';
        });

      item.classList.add('is-open');
      const popup = item.querySelector('.protection_item_pop');
      if (popup) popup.style.display = 'block';
      lockBody();

      return;
    }
    const closeBtn = e.target.closest('.close_protection_item_pop');
    if (closeBtn) {
      e.preventDefault();
      e.stopPropagation();
      const currentItem = closeBtn.closest('.item');
      if (currentItem) {
        currentItem.classList.remove('is-open');
        const popup = currentItem.querySelector('.protection_item_pop');
        if (popup) popup.style.display = 'none';
      }

      unlockBody();

      return;
    }

  });

});


// product bundle 
// product bundle 
document.addEventListener("DOMContentLoaded", function () {
  
  // 1. 核心方法：统一更新隐藏表单的 input 值
  function updateHiddenInputs() {
    let selectedValues = [];

    $(".custom_gift_bundling:checked").each(function () {
      selectedValues.push($(this).val());
    });

    let html = "";
    selectedValues.forEach(function (variantId, index) {
      html += `<input type="hidden" name="items[${index + 1}][id]" value="${variantId}">`;
    });

    $(".custom_free_bundling_wrapper").html(html);
  }

  // 2. 监听主复选框的勾选状态改变
  $(".custom_gift_bundling").on("change", function () {
    updateHiddenInputs();
  });

  // 3. 监听多变体下拉框的选择改变（包含价格与图片联动）
  const variantSelects = document.querySelectorAll('.product-bundling-variant-select');
  
  variantSelects.forEach(select => {
    select.addEventListener('change', function() {
      const selectedOption = this.options[this.selectedIndex];
      const variantId = this.value;
      
      // 找到当前商品卡片容器
      const productItem = this.closest('.bundles-items-product');
      const mainCheckbox = productItem ? productItem.querySelector('.bundle-main-checkbox') : null;
      
      if (mainCheckbox) {
        mainCheckbox.value = variantId;
      }

      // ---------------- 【新增】动态更新图片 ----------------
      const productImage = productItem.querySelector('.products-bundling-images_product');
      const newImageUrl = selectedOption.getAttribute('data-image');
      
      if (productImage && newImageUrl) {
        productImage.src = newImageUrl;
        // 如果使用了 lazyload（懒加载），通常需要同时更新 srcset 避免不刷新
        if (productImage.hasAttribute('srcset')) {
          productImage.removeAttribute('srcset'); 
        }
      }
      // ---------------------------------------------------

      // 动态更新前端显示的价格
      const priceSale = productItem.querySelector('.target-sale-price');
      const priceCompare = productItem.querySelector('.target-compare-price');
      
      const newPrice = selectedOption.getAttribute('data-price');
      const newComparePrice = selectedOption.getAttribute('data-compare-price');

      if (priceSale && newPrice) {
        priceSale.textContent = newPrice;
      }

      if (priceCompare) {
        if (newComparePrice) {
          priceCompare.textContent = newComparePrice;
          priceCompare.style.display = 'inline';
        } else {
          priceCompare.style.display = 'none';
        }
      }

      // 如果当前商品已经被勾选了，切换变体时立即同步更新隐藏域数据
      if (mainCheckbox && mainCheckbox.checked) {
        updateHiddenInputs();
      }
    });
  });

});


function toggleShowed() {
  var bundlesText = document.querySelector(".product-discount-shower-bundling");
  var bundlesbtnstext = document.querySelector(".product-bundles-btns-text");
  var BundlesDown = document.querySelector(".BundlesDown-icon");

  if (bundlesText.classList.contains("expanded")) {
    bundlesText.classList.remove("expanded");
    bundlesbtnstext.textContent = "Show more";
    BundlesDown.classList.remove("up");
  } else {
    bundlesText.classList.add("expanded");
    bundlesbtnstext.textContent = "Show less";
    BundlesDown.classList.add("up");
  }
}



document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".products-expand-bundling").forEach(container => {

    const wrapper = container.closest(".product-bundles-list-container");
    if (!wrapper) return;

    const footer = wrapper.querySelector(".bundles-footer");
    if (!footer) return;

    const button = footer.querySelector(".product-bundles-bespeak-item");
    const selectedCountEl = footer.querySelector(".selected-count");

    const items = container.querySelectorAll(".product-bundles__item");
    const checkboxes = container.querySelectorAll(".custom_gift_bundling");

    if (!button || !items.length) return;

    let collapsedHeight = 0;
    let isExpanded = false;

    // ✅ 记录每个 item 初始 hidden 状态
    const initialHiddenStates = Array.from(items).map(item => item.hasAttribute("hidden"));

    function calculateCollapsedHeight() {
      collapsedHeight = container.offsetHeight;
      if (!isExpanded) container.style.maxHeight = collapsedHeight + "px";
    }

    calculateCollapsedHeight();
    container.style.overflow = "hidden";

    // ✅ 计算当前 hidden 数量
    function getHiddenCount() {
      return Array.from(items).filter(item => item.hasAttribute("hidden")).length;
    }

    // 初始化按钮文字
    button.textContent = `Show (${getHiddenCount()}) more`;

    button.addEventListener("click", function () {
      if (!isExpanded) {
        // 展开
        items.forEach(item => item.removeAttribute("hidden"));
        container.style.maxHeight = container.scrollHeight + "px";
        button.textContent = "Show less";
      } else {
        // 收起 → 恢复原始 hidden 状态
        items.forEach((item, index) => {
          if (initialHiddenStates[index]) {
            item.setAttribute("hidden", "");
          } else {
            item.removeAttribute("hidden");
          }
        });
        container.style.maxHeight = collapsedHeight + "px";
        button.textContent = `Show (${getHiddenCount()}) more`;
      }
      isExpanded = !isExpanded;
    });

    window.addEventListener("resize", calculateCollapsedHeight);

    function updateSelectedCount() {
      const selected = Array.from(checkboxes).filter(cb => cb.checked).length;
      selectedCountEl.textContent = selected > 0 ? `${selected} Selected` : "";
    }

    checkboxes.forEach(cb => cb.addEventListener("change", updateSelectedCount));
  });

});
